<div [formGroup]="parentForm">
  <custom-label [placeholder]="placeholder"></custom-label>
      <span class="p-input-icon-left" [style]="styleProperties">
          <input
              [type]="type"
              [style]="styleProperties"
              border-round pInputText
              [placeholder]="placeholder"
              [(ngModel)]="ngValue"
              [formControlName]="nameInput"
              [ngClass]="{ 'is-invalid': nombreFormGroup && nombreFormGroup.status === 'INVALID' && (nombreFormGroup.touched == true || isSubmit) }"
              />
      </span>

      <div *ngIf="nombreFormGroup">
          <div *ngIf="nombreFormGroup.status == 'INVALID' && (nombreFormGroup.touched == true || isSubmit)">
              <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['required']">{{placeholder}}: Es obligatorio.</p>
              <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['minlength']">{{placeholder}}: No tiene el número de caracteres mínimo.</p>
              <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['maxlength']">{{placeholder}}: Supera el número máximo de caracteres.</p>
              <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['pattern']">{{placeholder}}: No tiene el formato correcto.</p>
              <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['email']">{{placeholder}}: No tiene el formato correcto para emails.</p>
              <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['min']">{{placeholder}}: Esta por debajo del valor mínimo permitido.</p>
              <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['max']">{{placeholder}}: Esta por encima del valor máximo permitido.</p>
              <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['mismatch']">{{placeholder}}: No coincide.</p>
          </div>
      </div>
  <div >
